import { render, staticRenderFns } from "./QuoteDetail.vue?vue&type=template&id=7f272224&scoped=true"
import script from "./QuoteDetail.vue?vue&type=script&lang=ts"
export * from "./QuoteDetail.vue?vue&type=script&lang=ts"
import style0 from "./QuoteDetail.scss?vue&type=style&index=0&id=7f272224&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f272224",
  null
  
)

export default component.exports